import { useMemo } from "react";

// import { FilterProps } from "react-table";

// interface SelectColumnFilterProps<T extends object> extends FilterProps<T> {}

/*
function SelectColumnFilter<T extends object>({
  column: { filterValue, setFilter, preFilteredRows, id },
}: SelectColumnFilterProps<T>)
*/

export const deepEqualFilterFn = (rows, id, filterValues) => {
  // const uniqueRowOptions = [...new Set(rows.map((row) => row.values[id]))];

  // if (!uniqueRowOptions.includes(filterValues)) return rows;

  return rows.filter((row) => {
    const rowValue = row.values[id];

    if (!rowValue || rowValue === "") return false; // Skip if row value is empty or null

    return rowValue === filterValues;
  });
};

function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  const options = useMemo(() => {
    const newOptions = new Set();
    preFilteredRows.forEach((row) => {
      newOptions.add(row.values[id]);
    });

    return [...newOptions.values()];
  }, [id, preFilteredRows]);

  return (
    <select
      id={id}
      className="form-control form-control-sm"
      value={filterValue}
      onChange={(event) => {
        setFilter(event.target.value || undefined);
      }}
    >
      <option value="">All</option>
      {options.map((option, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <option key={index} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
}

export default SelectColumnFilter;
